import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Pass-through layout for the /locations subtree. The list page lives at
 * /locations (locations.index.tsx) and the create page at /locations/new
 * (locations.new.tsx) — both render through this Outlet.
 */
export const Route = createFileRoute("/_authenticated/locations")({
  component: () => <Outlet />,
});
